/**
 * Appends (or prepends) a theme-wide icon image to primary/secondary buttons,
 * matching the Split hero button pattern. Skips inputs, close buttons, and
 * elements that already include a section-level icon.
 */
(function () {
  function getConfig() {
    return window.themeButtonIcon || null;
  }

  function shouldSkip(el, cfg) {
    if (!el || !cfg || !cfg.url) return true;
    if (el.tagName === 'INPUT') return true;
    if (!el.classList || !el.classList.contains('button')) return true;
    if (el.classList.contains('button-close')) return true;
    if (el.closest('[data-no-theme-button-icon]')) return true;
    if (el.querySelector('.split-hero__button-icon, .theme-button__icon')) return true;
    if (el.classList.contains('button--tertiary') && !cfg.includeTertiary) return true;
    return false;
  }

  function decorateButton(el, cfg) {
    if (shouldSkip(el, cfg)) return;
    var span = document.createElement('span');
    span.className = 'theme-button__icon';
    span.setAttribute('aria-hidden', 'true');
    var w = Number(cfg.size) || 24;
    span.style.width = w + 'px';
    span.style.height = w + 'px';
    var img = document.createElement('img');
    img.src = cfg.url;
    img.alt = '';
    img.width = w;
    img.height = w;
    img.loading = 'lazy';
    img.decoding = 'async';
    span.appendChild(img);
    if (cfg.position === 'before') {
      el.insertBefore(span, el.firstChild);
    } else {
      el.appendChild(span);
    }
    el.classList.add('theme-button--has-icon');
  }

  function addIcons(root) {
    var cfg = getConfig();
    if (!cfg || !cfg.url) return;
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('a.button, button.button');
    nodes.forEach(function (el) {
      decorateButton(el, cfg);
    });
  }

  function init() {
    addIcons(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) addIcons(event.target);
  });
})();
